import React from "react"
import {FieldTableCellProps, FieldTableCellState, getTableCellStyle} from "../../../../../../render/table/table-cell";
import Task from "../../../../../../../model2/task/task";
import {ScheduleStatus} from "../../../../../../../gd/types/types";
import formatDateHumanize from "../../../../../../../gd/format/date-humanize";
import {isBulkSelection} from "../../../../../../../gd/right-click-menu";

// const debug = "FieldTaskSchedule_TableCell"
const debug = false

// this one is quite unique I guess
// because of AR user

export default class FieldTaskSchedule_TableCell extends React.Component<FieldTableCellProps, FieldTableCellState> {

    constructor(props:FieldTableCellProps) {
        super(props)

        this.state = {
            isHovered       : false,
            showPopover     : false
        }
    }

    get canEdit():boolean {
        if (this.props.manager.isReadOnly) return false
        return this.props.field.canEdit(this.props.listItem.item)
    }

    onMouseEnter = () => {

        if (!this.canEdit) return

        if (!this.state.isHovered) this.setState({
            isHovered   : true
        })
    }

    onMouseLeave = () => {
        if (this.state.showPopover) return
        if (this.state.isHovered) this.setState({
            isHovered   : false
        })
    }

    async onValueChange(value: Moment|null, hidePopover:boolean=true) {

        hidePopover && this.hidePopover()

        this.props.field.fieldParams.tableCellOnValueChange!(this.props.listItem, value, this.props.manager)
    }

    onDeleteClick = async (e:React.MouseEvent)=>{
        if (isBulkSelection(e)) return
        e.stopPropagation()
        this.onValueChange(null)
    }

    onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        if (!this.canEdit) return
        this.setState({
            showPopover     : !this.state.showPopover
        })
    }

    hidePopover = () => {
        this.setState({
            showPopover     : false,
            isHovered       : false
        })
    }

    get classes():string {
        const classes = Classes("ui5-field-editable", this.props.className, {
            // "ui5-txt-default"               : this.props.size === FieldViewSize.DEFAULT,
            // "size-default"                  : this.props.size === FieldViewSize.DEFAULT,
            // "ui5-txt-less-important-small"  : this.props.size === FieldViewSize.SMALL,
            // "size-small"                    : this.props.size === FieldViewSize.SMALL,
            "ui5-txt-less-important-small"  : true,
            "size-small"                    : true,
        })
        return classes
    }

    getScheduleTitle(task: Task) {

        switch (task.scheduleStatus){
            case ScheduleStatus.NOT_SCHEDULED:
                return this.props.field.label
            case ScheduleStatus.SCHEDULED:
                return formatDateHumanize(task.scheduleDate!)

            case ScheduleStatus.SOMEDAY:
                return "Someday"
            default :
                return this.props.field.label
        }
    }


    renderValue() {
        const task = this.props.listItem.task
        const title = this.getScheduleTitle(task)
        const classes   = Classes("ui5-txt-less-important-small", "txt-truncate", {
            'ui5-color-red'    : this.props.field.fieldParams.highlightIfPastdue && task.scheduleDate?.isBefore(moment(),'day')
        })

        return (
            <div className={classes}>
                {title}
            </div>
        );
    }

    renderNoARHovered() {
        const classes = Classes("cell-flex ui5-txt-no-accent-small", this.props.column.id, {
            // 'is-hovered'        : this.state.isHovered
        })
        const task = this.props.listItem.task

        return (
            <React.Fragment>
                <div className={classes} style={getTableCellStyle(this.props)} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                    No AR user
                </div>
            </React.Fragment>
        )
    }

    renderHovered() {

        const actionRequiredUser = this.props.listItem.task.actionRequiredUserId
        if (!actionRequiredUser) return this.renderNoARHovered()

        const task = this.props.listItem.task
        const field = this.props.field

        const classes = Classes("cell-flex", {
            'is-hovered'        : this.state.isHovered
        })

        return (
            <React.Fragment>
                <div className={classes} style={getTableCellStyle(this.props)} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} >
                    <div className="ui5-field-editable size-small is-hovered w-100-percent h-100-percent" onClick={this.onClick}>

                        {this.renderValue()}

                        <div className="buttons flex-no-shrink">
                            {!!task.scheduleStatus && <div className="btn-reset" onClick={this.onDeleteClick}/>}
                            <div className="btn-arrow"/>
                        </div>

                    </div>

                    {this.state.showPopover &&
                        <field.components.PopoverMenu
                            parent={this}
                            field={this.props.field}
                            value={task.scheduleDate}
                            listItem={this.props.listItem}
                            manager={this.props.manager}
                        />
                    }
                </div>
            </React.Fragment>
        )
    }




    renderNotHovered() {
        const classes = Classes("cell-flex", this.classes, {
            // 'is-hovered'        : this.state.isHovered
        })
        const task = this.props.listItem.task

        return (
            <React.Fragment>
                <div className={classes} style={getTableCellStyle(this.props)} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                    {!!task.scheduleStatus && this.renderValue()}
                </div>
            </React.Fragment>
        )
    }

    render() {
        // debug && console.log(debug, "render()", this.props)
        debug && console.log(debug, "render() isHovered=", this.state.isHovered)

        if (this.state.isHovered) return this.renderHovered()
        else return this.renderNotHovered()
    }
}



